module.exports = __webpack_public_path__ + "img/dinersclub.c4d014e7.svg";